var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"p-site-keyword-analysis-status"},[_c('Label',{attrs:{"size":"lg","variant":"main"}},[_vm._v(_vm._s(_vm.label.name[_vm.sort.name]))]),_vm._t("default",function(){return [_vm._v("の"+_vm._s(_vm.label.orderby[_vm.sort.orderby]))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }